import React, { createContext } from "react";
import { AxiosRequestConfig } from "axios";
import { FileState } from "../../reducers/fileReducer";

export interface SearchContextProps {
  fileState: FileState;
  getFile: (params: string | undefined, config: AxiosRequestConfig) => void;
}

export const INITIAL_FILE_STATE: FileState = {
  status: 0,
  filename: "",
  signedUrl: "",
};

export const SearchContext = createContext<SearchContextProps>({
  fileState: INITIAL_FILE_STATE,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  getFile: () => {},
});
